module.exports = require("next/dist/compiled/next-server/pages.runtime.prod.js");